import { z } from 'zod'

export type OpenEnrollmentFeatureFlags = {
  isOpenEnrollmentFeatureEnabled: boolean
  isApprovalTabEnabled: boolean
}

export type OpenEnrollmentCustomerConfigs = {
  isOpenEnrollmentEnabled: boolean
  isPeopleTabEnabled: boolean
}

export const OpenEnrollmentSectionEnum = {
  POLICY: 'POLICY',
  PEOPLE: 'PEOPLE',
  CONTRIBUTIONS: 'CONTRIBUTIONS',
  PLANS: 'PLANS',
  APPROVALS: 'APPROVALS',
} as const
export const OpenEnrollmentSectionSchema = z.nativeEnum(
  OpenEnrollmentSectionEnum
)
export type OpenEnrollmentSection = z.infer<typeof OpenEnrollmentSectionSchema>

export const OpenEnrollmentStatusEnum = {
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  LIVE: 'LIVE',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
} as const
export const OpenEnrollmentStatusSchema = z.nativeEnum(OpenEnrollmentStatusEnum)
export type OpenEnrollmentStatus = z.infer<typeof OpenEnrollmentStatusSchema>
